import Viewer from "./Viewer"
import Editor from "./Editor"

export default {
    name: "activityDiagramCondition",
    title: "Activity Diagram Condition",
    icon: require("./content-icon.svg"),
    category: "training",
    Viewer,
    Editor,
    Preview: Viewer
}